<template>
    <div class="not-found">

        <h1>{{ $i18n.gt('HEADING_PAGE_NOT_FOUND') }}</h1>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
    import Vue from 'vue'

    export default Vue.extend({
        name: 'NotFound',
    })

</script>
